import type { MessageDescriptor } from 'react-intl';

import approvalListMessages from 'view/approval-list/approval-list-stateless/messages';
import legacyBreadcrumbMessages from 'view/common/bread-crumbs/bread-crumbs-dumb/messages';
import requestListMessages from 'view/request-list/request-list-stateless/messages';
import userProfileMessages from 'view/user-profile/user-profile-stateless/messages';

export const staticHubBreadcrumbMessages: Record<
	'home' | 'requests' | 'approvals' | 'profile',
	MessageDescriptor
> = {
	home: legacyBreadcrumbMessages.breadcrumbsHome,
	requests: requestListMessages.title,
	approvals: approvalListMessages.title,
	profile: userProfileMessages.title,
};
